var data =`date,close,volume,open,high,low
2019/08/06,16.2900,30305930.0000,16.2000,16.6300,16.1600
2019/08/05,16.4600,26598610.0000,16.5700,16.6300,16.0300
2019/08/02,17.0300,23809370.0000,16.5400,17.2300,16.4600
2019/08/01,16.6800,35265440.0000,16.8300,17.4500,16.5900
2019/07/31,16.8000,30566770.0000,16.9800,17.3200,16.4750
2019/07/30,16.9300,33597170.0000,17.2300,17.3284,16.9000
2019/07/29,17.5000,25542300.0000,18.0100,18.1200,17.4400
2019/07/26,17.8900,55913060.0000,17.7000,18.3600,17.6200
2019/07/25,17.6900,88040540.0000,17.2300,18.0000,17.1200
2019/07/24,17.6100,143867600.0000,16.2200,17.6100,16.0799
2019/07/23,14.8300,78779020.0000,14.6600,14.9300,14.2500
2019/07/22,14.1500,26770030.0000,14.0200,14.4700,13.9800
2019/07/19,14.0200,30424350.0000,14.6200,14.6500,13.9600
2019/07/18,14.5500,19050850.0000,14.7200,14.9400,14.4300
2019/07/17,14.9300,13471280.0000,14.9000,15.1400,14.5600
2019/07/16,15.0000,24522970.0000,15.5000,15.5300,14.8900
2019/07/15,15.5000,16919610.0000,15.5900,15.7300,15.2800
2019/07/12,15.6100,39198850.0000,16.1600,16.2400,15.5300
2019/07/11,15.5700,26709650.0000,15.6100,15.9400,15.3850
2019/07/10,15.2600,17194510.0000,15.2600,15.3600,14.9716
2019/07/09,15.2500,26250620.0000,15.3000,15.5700,14.8000
2019/07/08,15.1400,14292930.0000,15.1200,15.3600,15.0100
2019/07/05,15.2300,26456120.0000,14.6600,15.2880,14.5500
2019/07/03,14.7600,15065240.0000,14.1000,14.7700,14.0800
2019/07/02,14.1000,17823900.0000,14.4600,14.4800,13.9800
2019/07/01,14.3500,18527850.0000,14.7300,14.8085,14.3400
2019/06/28,14.3000,20060070.0000,14.7600,14.7800,14.1800
2019/06/27,14.5800,13184950.0000,14.7600,14.8100,14.5599
2019/06/26,14.7100,18330750.0000,14.7500,14.9300,14.6400
2019/06/25,14.5300,25231140.0000,14.6900,15.0000,14.2800
2019/06/24,14.7600,27563120.0000,14.6800,15.0100,14.6400
2019/06/21,14.5600,13530770.0000,14.7900,14.8200,14.5300
2019/06/20,14.8400,18753970.0000,14.8300,15.0000,14.6300
2019/06/19,14.6700,26536720.0000,14.8500,14.8500,14.4600
2019/06/18,14.8600,56473200.0000,14.1400,14.9800,14.1200
2019/06/17,13.5500,26879850.0000,14.1700,14.1800,13.3950
2019/06/14,13.9600,24189740.0000,14.1500,14.1500,13.6500
2019/06/13,14.1100,25002970.0000,13.8500,14.3100,13.7500
2019/06/12,13.7500,17515760.0000,13.7100,13.9800,13.4767
2019/06/11,13.5400,21897990.0000,13.9300,13.9700,13.3850
2019/06/10,13.7700,25589840.0000,13.9500,14.0700,13.6950
2019/06/07,13.8700,28549260.0000,13.9100,14.1100,13.8200
2019/06/06,13.8200,57526810.0000,13.0000,14.1300,12.5600
2019/06/05,12.9400,30010820.0000,12.9900,13.1400,12.5950
2019/06/04,12.9500,53352510.0000,11.8500,12.9500,11.8450
2019/06/03,11.6900,33333280.0000,11.8800,12.3700,11.5300
2019/05/31,11.8900,29254280.0000,11.9900,12.1000,11.7628
2019/05/30,11.9900,28743950.0000,11.7200,12.1900,11.6250
2019/05/29,11.6800,18806840.0000,11.3100,11.6900,11.2400
2019/05/28,11.5700,46617080.0000,11.5800,11.6000,11.2200
2019/05/24,11.5600,29187160.0000,11.4500,11.8100,11.4000
2019/05/23,11.1200,24490370.0000,11.0500,11.3600,10.7600
2019/05/22,11.3100,19407370.0000,11.4200,11.6000,11.1850
2019/05/21,11.5400,18344770.0000,11.3000,11.5600,11.3000
2019/05/20,11.1900,19753880.0000,11.2700,11.3000,10.9800
2019/05/17,11.4900,24816970.0000,11.2400,11.6400,11.0900
2019/05/16,11.4200,36343790.0000,10.7200,11.5400,10.7200
2019/05/15,10.6600,12390520.0000,10.4500,10.7300,10.4000
2019/05/14,10.4900,19956280.0000,10.2300,10.6500,10.2000
2019/05/13,10.1100,15911860.0000,10.0500,10.3400,10.0400
2019/05/10,10.4900,23159720.0000,10.9200,10.9200,10.2800
2019/05/09,10.9800,15840650.0000,10.7100,11.1000,10.6500
2019/05/08,10.8200,21362080.0000,11.2400,11.2699,10.7900
2019/05/07,11.1700,20793150.0000,11.6600,11.7800,11.0700
2019/05/06,11.7700,12552520.0000,11.3900,11.8600,11.3800
2019/05/03,11.8000,19211740.0000,11.2503,11.8400,11.2503
2019/05/02,11.2400,12005040.0000,11.2300,11.2500,10.9900
2019/05/01,11.2000,13589920.0000,11.2000,11.3600,11.1400
2019/04/30,11.1400,16971970.0000,11.1600,11.3699,11.0200
2019/04/29,11.2200,21444490.0000,11.1000,11.2900,11.0600
2019/04/26,10.9100,23711050.0000,10.7300,11.1300,10.6900
2019/04/25,10.7900,51212370.0000,11.1300,11.1500,10.5100
2019/04/24,11.2600,106250600.0000,12.3500,12.4200,11.0600
2019/04/23,11.9900,61113830.0000,11.9400,12.2000,11.6742
2019/04/22,11.5300,20679480.0000,11.5500,11.7000,11.2300
2019/04/18,11.6700,24222480.0000,11.1800,11.7100,11.1800
2019/04/17,11.7500,14664350.0000,11.7600,11.8300,11.5200
2019/04/16,11.6900,19629650.0000,11.8000,11.8500,11.4800
2019/04/15,11.8500,10577770.0000,11.9000,12.0200,11.7900
2019/04/12,11.9700,15369380.0000,11.9800,12.0300,11.7000
2019/04/11,11.9000,20168360.0000,12.1000,12.3701,11.7900
2019/04/10,12.0200,44581480.0000,11.8400,12.2000,11.5650
2019/04/09,12.3500,26200020.0000,12.1600,12.4700,12.0600
2019/04/08,12.2700,42327720.0000,12.3100,12.6300,12.1900
2019/04/05,11.8400,58247050.0000,11.6400,12.0500,11.4500
2019/04/04,11.2800,28751250.0000,11.2300,11.5400,10.9800
2019/04/03,11.1600,16785480.0000,11.2900,11.5100,11.1100
2019/04/02,11.2200,19951560.0000,11.0100,11.3000,10.9300
2019/04/01,11.3600,22110770.0000,11.1400,11.5300,10.9200
2019/03/29,11.0200,13310050.0000,10.8600,11.0600,10.7700
2019/03/28,10.7900,10292290.0000,10.6100,10.9200,10.5800
2019/03/27,10.6400,11229940.0000,10.7500,10.8400,10.4300
2019/03/26,10.7600,10063960.0000,10.8300,10.9350,10.7000
2019/03/25,10.7200,13155790.0000,10.6800,10.8500,10.4600
2019/03/22,10.7300,25606360.0000,11.0000,11.4650,10.6800
2019/03/21,11.0100,14567900.0000,10.8600,11.0200,10.7600
2019/03/20,10.9400,18234730.0000,10.5200,11.0400,10.4500
2019/03/19,10.6300,21445710.0000,10.8900,11.0400,10.5700
2019/03/18,10.9400,25672700.0000,11.0400,11.2550,10.7100
2019/03/15,11.1600,51624710.0000,11.5600,11.6700,10.9300
2019/03/14,11.2800,80617040.0000,10.6000,11.3800,10.5500
2019/03/13,10.0500,14356500.0000,9.8800,10.0600,9.7650
2019/03/12,9.8800,16302280.0000,10.0400,10.0400,9.6800
2019/03/11,9.9600,21671700.0000,9.6000,10.0650,9.4300
2019/03/08,9.4800,15644810.0000,9.2150,9.5600,9.1800
2019/03/07,9.4900,28639920.0000,9.8500,9.8550,9.1600
2019/03/06,9.8700,18307280.0000,10.0000,10.0600,9.7700
2019/03/05,10.0800,17951230.0000,9.9100,10.1100,9.8250
2019/03/04,9.9200,21493080.0000,9.9000,10.0500,9.6400
2019/03/01,9.8000,21807120.0000,9.8600,10.1599,9.7550
2019/02/28,9.8000,16459730.0000,9.8500,9.9250,9.6300
2019/02/27,9.8100,21884190.0000,10.0800,10.1000,9.6800
2019/02/26,10.0800,30980900.0000,10.1200,10.4200,9.8250
2019/02/25,10.1200,44760030.0000,9.9000,10.2900,9.8500
2019/02/22,9.7100,30153940.0000,9.3900,9.8000,9.3200
2019/02/21,9.3900,19484560.0000,9.1400,9.4000,9.1300
2019/02/20,9.2400,21666390.0000,9.2500,9.3300,9.1400
2019/02/19,9.2800,22947920.0000,9.0500,9.3400,9.0500
2019/02/15,9.1200,17892790.0000,9.2000,9.2300,9.0400
2019/02/14,9.1900,32413900.0000,9.0500,9.3200,9.0100
2019/02/13,9.0700,37581970.0000,8.7500,9.2300,8.6700
2019/02/12,8.8000,39164340.0000,9.0200,9.1700,8.7700
2019/02/11,8.9900,38441080.0000,9.0300,9.1950,8.8500
2019/02/08,9.1000,55049790.0000,8.3700,9.1900,8.3000
2019/02/07,8.5700,53524380.0000,8.3600,8.6900,8.0400
2019/02/06,8.5900,148422900.0000,8.6100,9.0900,8.3500
2019/02/05,7.0400,56632550.0000,7.0200,7.0500,6.8000
2019/02/04,6.9300,37493930.0000,6.9250,6.9800,6.7000
2019/02/01,6.9100,21766410.0000,6.7800,7.1500,6.7300
2019/01/31,6.6800,19072600.0000,6.6800,6.8100,6.6500
2019/01/30,6.5700,16371650.0000,6.4700,6.6000,6.3100
2019/01/29,6.4300,14381070.0000,6.4200,6.5000,6.2900
2019/01/28,6.3400,12124200.0000,6.2700,6.3950,6.2000
2019/01/25,6.4000,19927170.0000,6.2400,6.4400,6.2000
2019/01/24,6.1700,15636500.0000,5.9400,6.2000,5.9100
2019/01/23,5.9900,13137970.0000,6.0100,6.1000,5.8700
2019/01/22,5.9300,19919420.0000,6.0700,6.2400,5.8800
2019/01/18,6.1800,36529580.0000,5.8300,6.1900,5.7400
2019/01/17,5.7400,26201960.0000,5.7200,5.8400,5.6500
2019/01/16,5.6400,65676100.0000,5.7300,5.9400,5.6300
2019/01/15,6.5400,14116970.0000,6.4700,6.5700,6.3762
2019/01/14,6.3100,10677630.0000,6.4600,6.5000,6.2400
2019/01/11,6.2800,11725390.0000,6.2100,6.4150,6.2000
2019/01/10,6.2200,15400690.0000,6.3700,6.4000,6.1100
2019/01/09,6.2800,30165270.0000,6.2000,6.3100,5.8400
2019/01/08,6.4000,16014100.0000,6.3000,6.4500,6.2100
2019/01/07,6.2100,14709620.0000,6.0000,6.2100,5.9200
2019/01/04,5.9500,18197570.0000,5.6700,5.9900,5.6300
2019/01/03,5.6800,16023750.0000,5.6700,5.8700,5.6300
2019/01/02,5.7900,15235920.0000,5.3800,5.8700,5.3500
2018/12/31,5.5100,15300990.0000,5.7600,5.8600,5.4200
2018/12/28,5.7100,19153910.0000,5.3500,5.7600,5.3500
2018/12/27,5.3500,12973280.0000,5.3000,5.4100,5.0800
2018/12/26,5.4200,16694180.0000,5.1200,5.4300,5.0200
2018/12/24,5.1800,15131330.0000,4.9600,5.3500,4.9600
2018/12/21,4.9900,31610970.0000,5.1200,5.1400,4.8200
2018/12/20,5.0700,25149200.0000,5.3500,5.4500,4.9600
2018/12/19,5.4100,12897280.0000,5.6500,5.7400,5.3500
2018/12/18,5.6500,13321360.0000,5.6100,5.8400,5.6100
2018/12/17,5.5800,20439860.0000,5.9200,5.9567,5.5100
2018/12/14,5.9200,13886590.0000,5.7800,6.0100,5.7600
2018/12/13,5.8600,13725430.0000,5.9600,5.9900,5.7100
2018/12/12,5.9100,14844770.0000,5.8000,6.1300,5.7800
2018/12/11,5.7500,12288410.0000,5.7600,5.9000,5.7300
2018/12/10,5.6700,16380650.0000,5.7700,5.9093,5.5700
2018/12/07,5.8000,15247270.0000,5.9800,6.1300,5.7500
2018/12/06,5.9700,16908160.0000,6.0700,6.1600,5.8050
2018/12/04,6.2100,16863660.0000,6.3000,6.4500,6.2100
2018/12/03,6.3600,22930510.0000,6.6100,6.6700,6.2800
2018/11/30,6.5100,10358160.0000,6.4000,6.5400,6.3100
2018/11/29,6.4000,8855724.0000,6.4700,6.5400,6.3300
2018/11/28,6.5100,10046920.0000,6.4900,6.5400,6.2700
2018/11/27,6.4000,12711850.0000,6.4700,6.5300,6.3100
2018/11/26,6.5000,10360710.0000,6.2700,6.5200,6.2400
2018/11/23,6.2000,5271157.0000,6.2800,6.4299,6.1745
2018/11/21,6.3500,15431070.0000,6.2100,6.4800,6.1700
2018/11/20,6.0900,18801750.0000,5.8600,6.2261,5.8000
2018/11/19,6.0500,20771260.0000,6.4100,6.4400,6.0200
2018/11/16,6.4900,19464350.0000,6.7700,6.8000,6.2800
2018/11/15,6.8200,12614190.0000,6.4200,6.8700,6.4200
2018/11/14,6.4800,15685030.0000,6.4500,6.6900,6.3900
2018/11/13,6.7100,10871330.0000,6.7300,6.7550,6.4500
2018/11/12,6.6500,15048620.0000,6.7500,6.8700,6.4669
2018/11/09,6.7900,14359870.0000,6.9000,6.9600,6.6600
2018/11/08,7.0200,10751340.0000,7.1500,7.2250,6.9900
2018/11/07,7.2000,14348240.0000,7.0900,7.2900,7.0800
2018/11/06,7.0900,15526600.0000,6.8600,7.2000,6.8501
2018/11/05,6.9000,14667450.0000,6.9000,6.9400,6.7000
2018/11/02,6.8200,26796230.0000,7.1000,7.1800,6.6600
2018/11/01,7.2000,31565790.0000,6.6000,7.2900,6.4600
2018/10/31,6.6100,27669850.0000,6.5700,6.6500,6.4500
2018/10/30,6.4300,35847190.0000,5.9300,6.5386,5.9100
2018/10/29,5.9900,32071800.0000,6.3500,6.5900,5.8900
2018/10/26,6.2800,79703200.0000,6.1300,6.2800,5.7700
2018/10/25,6.9900,43269220.0000,6.7100,7.0850,6.6900
2018/10/24,6.5900,21731560.0000,6.8400,6.9900,6.5900
2018/10/23,6.8200,24652670.0000,6.8400,6.9300,6.6800
2018/10/22,6.8400,12637940.0000,6.8500,6.9800,6.7200
2018/10/19,6.8100,19097610.0000,6.8900,6.9700,6.6700
2018/10/18,6.8100,16911110.0000,6.9600,7.0200,6.7600
2018/10/17,7.0600,20921810.0000,7.1900,7.3200,6.9301
2018/10/16,7.2500,28660320.0000,7.4100,7.4650,7.0500
2018/10/15,7.4000,22031910.0000,7.1900,7.4600,7.1200
2018/10/12,7.1800,36202440.0000,7.1800,7.3900,7.0500
2018/10/11,6.8100,31116070.0000,6.4900,7.0000,6.4600
2018/10/10,6.5900,38841360.0000,7.0000,7.0200,6.5900
2018/10/09,7.0000,40833900.0000,7.2400,7.4000,6.8350
2018/10/08,7.4800,27675580.0000,7.7000,7.7000,7.2650
2018/10/05,7.7700,31014770.0000,7.9900,8.0400,7.6000
2018/10/04,7.8000,36507100.0000,7.9500,7.9850,7.5600
2018/10/03,8.2300,14928870.0000,8.1700,8.3300,8.1300
2018/10/02,8.1800,25407350.0000,8.3200,8.3600,8.0100
2018/10/01,8.3600,22658840.0000,8.5000,8.5700,8.2250
2018/09/28,8.4800,31768580.0000,8.7500,8.7800,8.4000
2018/09/27,8.8000,17966720.0000,9.0200,9.0600,8.7700
2018/09/26,8.9900,21146730.0000,9.0900,9.1100,8.8750
2018/09/25,9.0500,37215680.0000,9.1900,9.4200,9.0300
2018/09/24,8.9500,33998450.0000,9.0500,9.4100,8.8600
2018/09/21,9.1400,51564350.0000,9.1800,9.3100,9.0100
2018/09/20,9.2100,26526650.0000,9.0300,9.2400,8.6700
2018/09/19,9.1600,33326160.0000,9.0800,9.2100,9.0200
2018/09/18,9.1300,18011310.0000,9.1500,9.3800,9.0800
2018/09/17,9.1800,22126420.0000,9.2800,9.3700,9.0900
2018/09/14,9.2900,30520250.0000,9.4500,9.8350,9.2600
2018/09/13,9.3500,24756340.0000,9.1700,9.4200,9.1000
2018/09/12,9.2000,51889510.0000,9.2900,9.4300,8.9000
2018/09/11,9.8900,31622840.0000,9.8500,10.1500,9.8500
2018/09/10,9.7400,28991360.0000,9.7800,9.9000,9.5500
2018/09/07,9.9300,26498770.0000,9.7500,10.1900,9.6300
2018/09/06,9.8000,33083250.0000,10.1100,10.1800,9.6200
2018/09/05,10.1100,24690870.0000,10.5000,10.5100,10.0600
2018/09/04,10.5900,26046150.0000,10.9200,10.9600,10.4300
2018/08/31,10.9000,14110750.0000,10.9800,11.0900,10.8800
2018/08/30,11.0800,19584540.0000,11.1500,11.2501,10.8750
2018/08/29,11.1700,13053900.0000,11.2400,11.3800,11.1500
2018/08/28,11.2900,24417810.0000,11.7600,11.8000,11.1900
2018/08/27,11.8100,11300540.0000,11.6500,11.8350,11.6400
2018/08/24,11.6300,10526580.0000,11.4700,11.7000,11.4100
2018/08/23,11.4000,11062200.0000,11.5000,11.6400,11.3950
2018/08/22,11.4400,12077810.0000,11.4100,11.6200,11.4100
2018/08/21,11.4400,21733710.0000,11.7500,11.8274,11.3350
2018/08/20,11.7300,13971330.0000,11.8000,11.8600,11.5700
2018/08/17,11.8900,22435230.0000,12.1600,12.1700,11.6300
2018/08/16,12.1700,14625300.0000,12.3000,12.5800,12.1000
2018/08/15,12.1800,13624680.0000,12.2700,12.3000,12.1100
2018/08/14,12.3400,13025410.0000,12.6500,12.7300,12.3100
2018/08/13,12.5700,15723540.0000,12.2400,12.7650,12.2400
2018/08/10,12.3100,15876830.0000,12.1400,12.5000,12.0900
2018/08/09,12.3100,24281540.0000,12.1500,12.6700,12.0700
2018/08/08,12.2300,61126100.0000,12.8300,12.8400,12.0400
2018/08/07,13.1200,48006610.0000,13.0100,13.3700,12.7800
2018/08/06,13.0500,17588710.0000,12.7300,13.1300,12.7100`

export default data;